import { render, staticRenderFns } from "./SignUpRecord.vue?vue&type=template&id=0df1ddc0&"
import script from "./SignUpRecord.vue?vue&type=script&lang=js&"
export * from "./SignUpRecord.vue?vue&type=script&lang=js&"
import style0 from "./SignUpRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports